const TrainingKitServiceBox = ({ service }) => {
    return (
        <div className='relative rounded-tr-[4rem] rounded-bl-[4rem] rounded-br-xl rounded-tl-xl bg-[#E6E6E614] border py-[2rem] px-4'>
            <div className='flex justify-center items-center'>
                <p className='text-white bg-secondary-tw px-8 py-1 rounded-md relative w-fit -top-12 z-20'>
                    {service.title}
                </p>
            </div>
            <ul className='space-y-4'>
                {service?.description?.map((desc, dId) => (
                    <li key={dId} className='text-start'>
                        <div className='flex items-center gap-2'>
                            <span className='size-5 flex justify-center items-center text-white bg-secondary-tw rounded-full text-xs'>{++dId}</span>
                            <span className="font-medium">{desc.title}</span>
                        </div>
                        <p className='text-semi-gray text-sm mr-6'>
                            {desc.detail}
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};
export default TrainingKitServiceBox;